import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { categories, projects } from '../data/researchData';
import './Research.css';

const Research = () => {
  const [searchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const categoryFromUrl = searchParams.get('category');
    if (categoryFromUrl && categories.find(c => c.id === categoryFromUrl)) {
      setSelectedCategory(categoryFromUrl);
    }
  }, [searchParams]);

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
  };

  const handleProjectClick = (categoryId, projectId) => {
    navigate(`/research/${categoryId}/${projectId}`);
  };

  const currentCategory = categories.find(c => c.id === selectedCategory);
  const currentProjects = selectedCategory ? projects[selectedCategory] : [];

  return (
    <div className="research-page_research">
      <div className="research-container_research">
        {/* Breadcrumb */}
        <div className="breadcrumb_research">
          <span className="breadcrumb-link_research" onClick={handleBackToCategories}>Home</span>
          <span className="breadcrumb-separator_research">»</span>
          {selectedCategory ? (
            <>
              <span className="breadcrumb-link_research" onClick={handleBackToCategories}>Research</span>
              <span className="breadcrumb-separator_research">»</span>
              <span className="breadcrumb-current_research">{currentCategory?.name}</span>
            </>
          ) : (
            <span className="breadcrumb-current_research">Research</span>
          )}
        </div>

        {/* Page Title */}
        <h1 className="page-title_research">
          {selectedCategory ? currentCategory?.name : 'Research Areas'}
        </h1>

        {/* Main Categories View */}
        {!selectedCategory && (
          <div className="cards-grid_research">
            {categories.map((category) => (
              <div
                key={category.id}
                className="card-item_research"
                onClick={() => handleCategoryClick(category.id)}
              >
                <img src={category.image} alt={category.name} className="card-image_research" />
                <div className="card-overlay_research">
                  <h3 className="card-title_research">{category.name}</h3>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Subcategory/Projects View */}
        {selectedCategory && (
          <>
            <button className="back-btn_research" onClick={handleBackToCategories}>
              ← Back to Research Areas
            </button>
            <div className="cards-grid_research three-col_research">
              {currentProjects.map((project) => (
                <div
                  key={project.id}
                  className="card-item_research"
                  onClick={() => handleProjectClick(selectedCategory, project.id)}
                >
                  <img src={project.image} alt={project.title} className="card-image_research" />
                  <div className="card-overlay_research">
                    <h3 className="card-title_research">{project.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Research;